import { isAxiosError } from 'axios';
import { InsightsError } from './InsightsError';
export class HttpError extends InsightsError {
    constructor(code, status, message, response) {
        super(code, message);
        this.code = code;
        this.status = status;
        this.response = response;
        this.isHttpError = true;
        this.responseHeaders = {};
    }
    static fromAxiosResponse(code, message, response) {
        const status = response.status;
        const error = new HttpError(code, status, message, response.data);
        error.responseHeaders = response.headers;
        return error;
    }
    static fromAxiosError(code, error) {
        var _a, _b, _c, _d, _e, _f;
        if (!isAxiosError(error)) {
            throw new Error('Cannot generate HttpError from a non-Axios error.');
        }
        const status = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 0;
        const message = (_c = error.message) !== null && _c !== void 0 ? _c : 'Unknown error';
        const httpError = new HttpError(code, status, `HTTP ${status}: ${message} (${(_d = error.code) !== null && _d !== void 0 ? _d : 'Unknown'})`, (_e = error.response) === null || _e === void 0 ? void 0 : _e.data);
        httpError.responseHeaders = (_f = error.response) === null || _f === void 0 ? void 0 : _f.headers;
        return httpError;
    }
}
export const isHttpError = (error) => {
    return error instanceof HttpError && error.hasOwnProperty('isHttpError') && error.isHttpError === true;
};
